import { render, staticRenderFns } from "./fawaterk-checkout.vue?vue&type=template&id=6dff4211"
import script from "./fawaterk-checkout.vue?vue&type=script&lang=js"
export * from "./fawaterk-checkout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports